import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import SidebarEstudiante from '../SidebarEstudiante';
import { Header } from './Header';
import { useExamContext } from '../../context/ExamContext';
import './MainLayout.css';

function MainLayout({ children }) {
  const { hideSidebar } = useExamContext();

  return (
    <div className="main-layout-wrapper">
      {!hideSidebar && <Header className="main-layout-header" />}
      <div className="main-layout-container">
        {!hideSidebar && (
          <SidebarEstudiante 
            onSelectOption={undefined}
            selectedOption={undefined}
          />
        )}
        <main className={`main-layout-content ${hideSidebar ? 'main-layout-content-full' : ''}`}>
          {children}
        </main>
      </div>
    </div>
  );
}

export default MainLayout;

